<template>
    <div id="news_create" class="fleet-form-main">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <span class="page-title" id="roleHeader" v-if="$route.params.id > 0">Update News</span>
                    <span class="page-title" id="roleHeader" v-else>Add News</span>
                    <button type="submit" class="btn btn-secondary pull-right" v-on:click.prevent="BackNewsList" >
                        <i class="fp-back"> </i> Back
                    </button>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content news-crud">
                        <section class="internal-container border-top-table-fl">
                            <form autocomplete="off" class="form-horizontal basic-form-container form-custom-select" id="RoleForm">
                                <div class="form-row row-cols-md-2 row-cols-1">
                                    <div class="col form-group">
                                        <label class="control-label require" for="name">Subject:</label>
                                        <input type="text" class="form-control" v-model="subject" id="name" placeholder="Enter Subject" name="subject">
                                        <div class="field-error">{{subject_error_msg}}</div>
                                    </div>
                                </div>
                                <div class="form-row row-cols-md-2 row-cols-1">
                                    <div class="col form-group">
                                        <label class="control-label require" for="name">Description:</label>
                                        <template>
                                            <div id="app">
                                                <vue-editor v-model="description" :editorToolbar="customToolbar"></vue-editor>
                                            </div>
                                            <div class="field-error">{{description_error_msg}}</div>
                                        </template>
                                    </div>
                                </div>
                                <div class="form-row row-cols-md-2 row-cols-1">
                                    <div class="col form-group">
                                        <label class="control-label require" for="file">File:</label> <br/>
                                        <div class="custom-upload-container ml-0" data-provides="fileupload">
                                            <label for="physicalFiles" class="fileupload-new btn btn-secondary"><i class="fp-upload"></i>Upload</label>
                                            <label for="physicalFiles" class="fileupload-exists btn btn-secondary hide">Change</label>
                                            <input class="hide" type="file" id="physicalFiles" ref="files" v-on:change="handleFilesUpload()"/>
                                            <div class="field-error">{{fileerror_msg}}</div>
                                        </div>
                                        <template v-for="(file, key) in filesArr">
                                            <div v-bind:key="key" class="file-container" :id="'fileDiv'+file.id">
                                                <span class="fileupload-preview wrappath">{{ file.name }}</span>
                                                <a href="javascript:void(0)" :class="'close'" data-dismiss="fileupload" v-on:click="deleteDoc(file.id,key)" style="float: right">
                                                    <i class="fp-delete"></i>
                                                </a>
                                            </div>
                                        </template>
                                        <template  v-for="(files, key1) in existFilesArr">
                                            <div v-bind:key="'fileDiv'+key1" class="attachment-list mt-3">
                                                <i v-if="files.ext == 'pdf'" class="fp-pdf-icon"></i>
                                                <i v-if="files.ext == 'doc' || files.ext == 'docs'" class="fp-text-document"></i>
                                                <i v-if="files.ext == 'jpg' ||  files.ext == 'png' ||  files.ext == 'jpeg' " class="fp-image"></i>
                                                <a title='View File' href="javascript:void(0)"  v-on:click="openDocument(files.url,files.ext)" v-bind:key="'fileName'+key1" >
                                                    {{ files.display_name }}
                                                </a>
                                                &nbsp;&nbsp;&nbsp;&nbsp;
                                                <button type="button" class="pull-right"  v-bind:key="'cancelBtn'+key1" v-on:click="deleteNewsFile(key1,files.path);">
                                                    <i class="fp-close color-red"></i>
                                                </button>
                                            </div>
                                        </template>
                                    </div>
                                </div>
                                <div class="form-row row-cols-md-2 row-cols-1">
                                    <div class="col form-group">
                                        <label class="control-label require" for="name">File Alter Text:</label>
                                        <input type="text" class="form-control" v-model="alterText" id="alter_text" placeholder="Enter Alter Text" name="alter_text">
                                        <div class="field-error">{{file_alter_error_msg}}</div>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <div class="alert alert-warning hide col-sm-6" id="alertError">
                                        <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                        <strong id="errorMsg" class="field-error"></strong>
                                    </div>
                                </div>
                                <div class="btn-groups">
                                    <button type="submit" id="createNewsBtn" v-if="$route.params.id > 0" class="btn btn-primary" v-on:click.prevent="CreateNews">
                                    <i class="fp-reload"> </i>  Update
                                    </button>
                                    <button type="submit" id="createNewsBtn" v-else class="btn btn-primary" v-on:click.prevent="CreateNews" >
                                    <i class="fp-save"> </i>  Save
                                    </button>
                                    <button type="submit" id="createAndContinueNewsBtn" v-if="$route.params.id == undefined" class="btn btn-tertiary" v-on:click.prevent="CreateNews(flag='Save and Continue')" >
                                    <i class="fp-save-continue"> </i>  Save and Continue
                                    </button>
                                    <button type="submit" id="cancelNewsBtn" class="btn btn-tertiary" v-on:click.prevent="BackNewsList">
                                    <i class="fp-close"> </i>  Cancel
                                    </button>
                                </div>
                            </form>
                        </section>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>

    </div>
</template>
<script>
import Vue from "vue";

import {commonMixins} from '../mixins/commonMixins';

// import { VueEditor } from "vue2-editor";

// Advanced Use - Hook into Quill's API for Custom Functionality
import { VueEditor } from "vue2-editor";


export default {
  name: "NewsCreate",
  components: {
        VueEditor
    },
  mixins:[commonMixins],
  data: () => ({
    subject: "",
    loading:false,
    permissions: [],
    cantAccessPage: "",
    subject_error_msg: "",
    description:'',
    // slug:'',
    filesArr:[],
    alterText:'',
    existFilesArr:[],
    fileerror_msg:'',
    // slug_error_msg:'',
    file_alter_error_msg:'',
    description_error_msg:'',
    editorSettings: {
        modules: {
        imageDrop: false,
        imageResize: {}
        }
    },
    customToolbar : [
        [{ header: [false, 1, 2, 3, 4, 5, 6] }],
        ["bold", "italic", "underline", "strike"], // toggled buttons
        [
            { align: "" },
            { align: "center" },
            { align: "right" },
            { align: "justify" }
        ],
        ["blockquote", "code-block"],
        [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
        [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
        [{ color: [] }, { background: [] }], // dropdown with defaults from theme
        ["link"],
        ["clean"] // remove formatting button
        ]
  }),
  watch:{
        //check permission change
        permissions: function (permissions) {

            var self = this;
            if (permissions.length > 0) {
                for (var i = 0; i < permissions.length; i++) {
                    if (permissions[i].name == 'add_news' ) {
                        self.cantAccessPage = true;
                    }
                }
            }
        },

        // subject: function(newVal){
        //     var self = this;
        //     if (newVal.indexOf(' ') > 0){

        //         newVal = newVal.split(' ').join('-');

        //     }

        //     self.slug = newVal.toLowerCase();
        // }
  },
  created: function() {

  },
  mounted: function() {
        var self = this;
        self.getPermissions();
         setTimeout(function () {
            var path = window.location.pathname;
            var segments = path.split("/");

            if (segments[3]) {

                self.loadNews();

            }
        }, 100);
  },
  methods: {

    BackNewsList() {
      var self = this;
      self.$router.push("/news/list");
    },

    CreateNews(flag) {
      var self = this;

      self.subject_error_msg = "";
      self.fileerror_msg = "";
      self.file_alter_error_msg = "";
      self.description_error_msg = '';

      var error = false;
      const fields = new FormData();

      if (!self.subject || self.subject == null || self.subject == "") {
        self.subject_error_msg = "Subject Required.";
        error = true;
      }

      if (!self.description || self.description == null || self.description == "") {
        self.description_error_msg = "Description Required.";
        error = true;
      }
      if (!self.alterText || self.alterText == null || self.alterText == "") {
        self.file_alter_error_msg = "File Alter Text Required.";
        error = true;
      }

      if(self.filesArr.length < 1 && self.existFilesArr.length < 1){
            self.fileerror_msg = 'File required';
            error = true;
        }
        for (var i = 0; i < self.filesArr.length; i++) {

            let file = self.filesArr[i];

            if(file.type == "image/jpeg" || file.type == "image/png") {

            } else {
                self.fileerror_msg = 'Only Images Files Are Allowed (.png / .jpeg )';
                error = true;
            }
        }


        if (!error){

            self.loading = true;
            var path = window.location.pathname;
            var segments = path.split("/");
            if (segments[3])
            {
                $("#createNewsBtn").val("Updating ...");
                $("#createNewsBtn").prop("disabled", true);
                $("#cancelNewsBtn").prop("disabled",true);
            } else {
                if (flag == "Save and Continue") {

                    $("#createAndContinueNewsBtn").val("Saving ...");
                    $("#createNewsBtn").prop("disabled", true);
                    $("#createAndContinueNewsBtn").prop("disabled", true);
                    $("#cancelNewsBtn").prop("disabled",true);

                }else{

                    $("#createNewsBtn").val("Saving ...");
                    $("#createNewsBtn").prop("disabled", true);
                    $("#createAndContinueNewsBtn").prop("disabled", true);
                    $("#cancelNewsBtn").prop("disabled",true);
                }

            }

            fields.append(
                "subject",
                self.subject
            );

            // fields.append(
            //     "slug",
            //     self.slug
            // );

            fields.append(
                "description",
                self.description
            );

            fields.append(
                "alter_text",
                self.alterText
            );



            for (var i = 0; i < self.filesArr.length; i++) {
                let file = this.filesArr[i];
                fields.append("files", file);
            }
            if (segments[3]){
                fields.append(
                "id",
                segments[3]
                );
            }

            $.ajax({
                url: process.env.ROOT_API + "/news/create",
                type: "POST",
                data: fields,
                headers: this.ajxHeaders,
                dataType: "json",
                crossDomain: true,
                processData: false,
                contentType: false,
                success: function (data) {
                    self.loading = false;
                    if (segments[3])
                    {
                        $("#createNewsBtn").val("Update");
                        $("#createNewsBtn").prop("disabled", false);
                        $("#cancelNewsBtn").prop("disabled",false);
                    } else {
                        if (flag == "Save and Continue") {

                            $("#createAndContinueNewsBtn").val("Save and Continue");
                            $("#createNewsBtn").prop("disabled", false);
                            $("#createAndContinueNewsBtn").prop("disabled", false);
                            $("#cancelNewsBtn").prop("disabled",false);

                        }else{

                            $("#createNewsBtn").val("Save");
                            $("#createNewsBtn").prop("disabled", false);
                            $("#createAndContinueNewsBtn").prop("disabled", false);
                            $("#cancelNewsBtn").prop("disabled",false);
                        }

                    }
                    if (data.status == "exist") {

                        var err = data.message;

                        $("#errorMsg").html(err);
                        $(".alert-warning").toggleClass("show");
                        setTimeout(function () {
                            $(".alert-warning").removeClass("show");
                            $(".alert-warning").addClass("hide");
                        }, 10000);

                        return;
                    }

                    if (data.status == "success") {

                        if (flag == "Save and Continue") {

                            // $("#RoleForm").trigger("reset");
                            self.subject = "";
                            self.description = "";
                            // self.slug = "";
                            self.filesArr = [];
                            self.alterText = '';

                        }else{
                            self.$router.push("/news/list");
                        }

                    } else {
                        if (data.content.length > 0) {
                            var err = "";
                            for (var i = 0; i < data.content.length; i++) {
                                err += data.content[i] + "<br>";
                            }
                            $("#errorMsg").html(err);
                            $(".alert-warning").toggleClass("show");
                            setTimeout(function () {
                                $(".alert-warning").removeClass("show");
                                $(".alert-warning").addClass("hide");
                            }, 10000);
                        }
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    if (segments[3])
                    {
                        $("#createNewsBtn").val("Update");
                        $("#createNewsBtn").prop("disabled", false);
                        $("#cancelNewsBtn").prop("disabled",false);
                    } else {
                        if (flag == "Save and Continue") {

                            // $("#RoleForm").trigger("reset");
                            self.subject = "";
                            $("#createAndContinueNewsBtn").val("Save and Continue");
                            $("#createNewsBtn").prop("disabled", false);
                            $("#createAndContinueNewsBtn").prop("disabled", false);
                            $("#cancelNewsBtn").prop("disabled",false);

                        }else{

                            $("#createNewsBtn").val("Save");
                            $("#createNewsBtn").prop("disabled", false);
                            $("#createAndContinueNewsBtn").prop("disabled", false);
                            $("#cancelNewsBtn").prop("disabled",false);

                        }
                    }
                    if (jqXHR.status == 0) {
                        self.errorMsg = "Remote server cannot be reached";
                    } else {
                        //redirect to login page if user not authenticated
                        if (jqXHR.status == 401) {
                            //clear previous data
                            localStorage.removeItem("user_obj");
                            localStorage.removeItem("tkn");

                            self.$router.push("/");
                        }
                        $("#errorMsg").html(jqXHR.responseJSON.message);
                        $(".alert-warning").toggleClass("show");
                        setTimeout(function () {
                            $(".alert-warning").removeClass("show");
                            $(".alert-warning").addClass("hide");
                        }, 10000);
                    }
                }
            });
        }else{
            self.errorValidationFocus();
        }
    },

    loadNews() {
        var path = window.location.pathname;
        var segments = path.split("/");
        var self = this;
        self.loading = true;
        $.ajax({
            url: process.env.ROOT_API + "/news/" + segments[3],
            type: "GET",
            headers: this.ajxHeaders,
            dataType: "json",
            success: function (data) {
                self.loading = false;
                console.log(data);
                if (data.status == "success") {
                    self.subject = data.content.subject;
                    // self.slug = data.content.slug;
                    self.description = data.content.description;
                    self.alterText = data.content.alter_text;
                    if (data.content.files){

                        self.existFilesArr.push(data.content.files);

                    }else{
                        self.existFilesArr = [];
                    }
                }
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                if (jqXHR.status == 0) {
                    self.errorMsg = "Remote server cannot be reached";
                } else {
                    //redirect to login page if user not authenticated
                    if (jqXHR.status == 401) {
                        //clear previous data
                        localStorage.removeItem("user_obj");
                        localStorage.removeItem("tkn");

                        self.$router.push("/");
                    }
                    self.error = jqXHR.responseJSON.message;
                }
            }
        });
    },

    handleFilesUpload: function(event) {
        /* Get the uploaded files from the input.*/

        var self = this;
        self.filesArr = [];
        self.fileerroor_msg = "";

        let uploadedFiles = "";
        self.uploadBtn= "Uploading...";
        uploadedFiles = self.$refs.files.files;
        for (var i = 0; i < uploadedFiles.length; i++) {

            this.filesArr.push(uploadedFiles[i]);

        }
        console.log(this.filesArr);
        this.$refs.files.value = '';
        self.uploadBtn= "Upload";
     },
     deleteDoc: function(id,key) {
          var self = this;

          if (confirm('Are you sure that you want to remove file? ')) {

                self.submitBtn = false;
                console.log( self.$refs.files);
                this.filesArr.splice(key,1)
                self.$refs.files.value = '';
                if (self.valuesFound) {
                    self.valuesFound = false;
                    self.matchingValuesError = [];
                }
          }
          return;

      },

     deleteNewsFile: function(key,file){
         var self = this;

        var path = window.location.pathname;
        var segments = path.split("/");

        var newsId = segments[3];

        if (confirm('Are you sure that you want to remove file? ')) {

            if ( newsId != '' && newsId != undefined ) {

                self.loading = true;

                $.ajax({
                    url: process.env.ROOT_API + "/remove-news-file",
                    type: "POST",
                    crossDomain: true,
                    dataType: "json",
                    headers: this.ajxHeaders,
                    data: {
                        news_id:newsId,
                        doc_path:file
                    },
                    success: function(data) {
                        self.loading = false;
                        //console.log(data.content[0]["id"]);
                        if (data.status == "success") {

                            self.loadNews();
                            // $("#myModal").modal("hide");
                            self.$refs.files.value = '';
                        }
                    },
                    error: function(jqXHR, exception) {
                        self.loading = false;
                        self.files.splice(key,1);
                        if (jqXHR.status == 0) {
                            self.error = "Remote server cannot be reached";
                        } else {
                            self.error = jqXHR.responseJSON.message;
                        }
                    }
                });

            } else{

                self.filesArr.splice(key,1);
                self.$refs.files.value = '';
            }
        }

     }
  }
};
</script>




// WEBPACK FOOTER //
// src/components/NewsCreate.vue